import { c as _c } from "react/compiler-runtime";
import { ContextMenu, ContextMenuItem } from '@repo/design-system/components/ui/context-menu';
import { useT } from '@repo/i18n/components/i18n.client';
interface RegionContextMenuProps {
  x: number;
  y: number;
  regionTitle: string;
  isRegionHidden: boolean;
  onToggle: () => void;
  onShowOnly: () => void;
  onMarkAllFound: () => void;
  onMarkAllUnfound: () => void;
  onClose: () => void;
}
export const RegionContextMenu = t0 => {
  const $ = _c(39);
  const {
    x,
    y,
    regionTitle,
    isRegionHidden,
    onToggle,
    onShowOnly,
    onMarkAllFound,
    onMarkAllUnfound,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  let t2;
  if ($[1] !== onMarkAllFound || $[2] !== onMarkAllUnfound || $[3] !== onShowOnly || $[4] !== onToggle) {
    t2 = details => {
      if (details.value === "toggle-region") {
        onToggle();
      } else {
        if (details.value === "show-only-region") {
          onShowOnly();
        } else {
          if (details.value === "mark-found") {
            onMarkAllFound();
          } else {
            if (details.value === "mark-unfound") {
              onMarkAllUnfound();
            }
          }
        }
      }
    };
    $[1] = onMarkAllFound;
    $[2] = onMarkAllUnfound;
    $[3] = onShowOnly;
    $[4] = onToggle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onClose) {
    t3 = details_0 => {
      if (!details_0.open) {
        onClose();
      }
    };
    $[6] = onClose;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== x || $[9] !== y) {
    t4 = {
      x,
      y
    };
    $[8] = x;
    $[9] = y;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t(_temp);
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <ContextMenuItem value="mark-found" leadingIcon="check_circle">{t5}</ContextMenuItem>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t(_temp2);
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <ContextMenuItem value="mark-unfound" leadingIcon="cancel">{t7}</ContextMenuItem>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== regionTitle || $[20] !== t) {
    t9 = t(_temp3, {
      regionName: regionTitle
    });
    $[19] = regionTitle;
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <ContextMenuItem value="show-only-region" leadingIcon="filter_alt">{t9}</ContextMenuItem>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = isRegionHidden ? "visibility" : "visibility_off";
  let t12;
  if ($[24] !== isRegionHidden || $[25] !== regionTitle || $[26] !== t) {
    t12 = isRegionHidden ? t(_temp4, {
      regionName: regionTitle
    }) : t(_temp5, {
      regionName: regionTitle
    });
    $[24] = isRegionHidden;
    $[25] = regionTitle;
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <ContextMenuItem value="toggle-region" leadingIcon={t11}>{t12}</ContextMenuItem>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t10 || $[32] !== t13 || $[33] !== t2 || $[34] !== t3 || $[35] !== t4 || $[36] !== t6 || $[37] !== t8) {
    t14 = <ContextMenu open={true} closeOnSelect={false} onSelect={t2} onOpenChange={t3} anchorPoint={t4}>{t6}{t8}{t10}{t13}</ContextMenu>;
    $[31] = t10;
    $[32] = t13;
    $[33] = t2;
    $[34] = t3;
    $[35] = t4;
    $[36] = t6;
    $[37] = t8;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
};
function _temp($) {
  return $.mark_all_found;
}
function _temp2($_0) {
  return $_0.mark_all_unfound;
}
function _temp3($_1) {
  return $_1.show_only_pins_in_region;
}
function _temp4($_2) {
  return $_2.show_pins_in_region;
}
function _temp5($_3) {
  return $_3.hide_pins_in_region;
}